/**
 @name: 各版块详情页面的推荐列表
 @description:
 @author: 王耀民
 @time: 2021年12月15日15:50:02
 **/
import request from '@/http'

export const api = {
  // getTeamRecommend: (data) => request.get(`/teamInfo/teamRecommend`, data), // 施工队/班组工队
  getTeamRecommend: (data) => request.get(`/teamInfo/teamPopularRecommend`, data), // 施工队/班组工队获取推荐列表v2.2.1修改
  getLaborEmploymentRecommend: (data) => request.get(`/laborEmployment/laborEmploymentRecommend`, data), // 劳务用工
  getWorkerRecommend: (data) => request.get(`/worker/workerRecommend`, data), // 专业工人
  getEmploymentRecommend: (data) => request.get(`/employment/employmentRecommend`, data), // 临时用工
}
